import { Injectable, Injector } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private authService!: AuthService;

  constructor(
    private toastr: ToastrService,
    private injector: Injector,
  ) {}

  private getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }

  handleError(error: HttpErrorResponse) {
    console.error('Error:', error);

    switch (error.status) {
      case 401:
        // El interceptor ya notificó y cerró la sesión.
        break;
      case 403:
        this.getAuthService().logout();
        this.toastr.error('La sesión ha expirado', 'Unauthorized');
        break;
      case 400:
        if (error.error) {
          const validationErrors = error.error.errors ?? (error.error.message ? null : error.error);
          if (validationErrors && typeof validationErrors === 'object') {
            Object.values(validationErrors).forEach(message => {
              this.toastr.error(String(message), 'Datos inválidos');
            });
          } else {
            this.toastr.error(error.error.message ?? 'Datos inválidos', 'Datos inválidos');
          }
        }
        break;
      case 409:
        this.toastr.error(error.error?.message, 'Conflict');
        break;
      default:
        this.toastr.error('Contacta al administrador', 'Error en el servidor');
        break;
    }
  }
}
